module.exports = __webpack_public_path__ + "static/img/title-button4.8fefc89f.png";